module.exports = __webpack_public_path__ + "images/bluekens8109c066f999c13417bb1f656f2c5037.png";